import "./App.css";
import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import axios from "axios";

import Loader from "./Admin/Loader";
import Mainfol from "./Admin/Mainfol";

import ProtectedRoute from "./ProtectedRoute";
import RoleRoute from "./RoleRoute";

import LoginPage from "./Admin/LoginPage";
import Dashboard from "./Admin/Dashboard";
import Branches from "./Admin/Pages/Branches";
import Candidates from "./Admin/Pages/Candidates";
import Unauthorized from "./Unauthorized";
import Project from "./Admin/Pages/Project";
import ServerDown from "./ServerDown";
import Log from "./Admin/Pages/Log";
import AssetsManagement from "./Admin/Pages/AssetsManagement";

 
function App() {
  const [checking, setChecking] = useState(true);
  const [serverDown, setServerDown] = useState(false);

  // ✅ REAL SERVER CHECK (runs on refresh)
 
 

  

   return (
    <BrowserRouter>
      <Loader />

      <Routes>
        {/* Default */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Login */}
        <Route path="/login" element={<LoginPage />} />

        {/* Unauthorized */}
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* PROTECTED */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Mainfol />
            </ProtectedRoute>
          }
        >
      <Route
  path="dash"
  element={
    <RoleRoute allowed={["admin", "branchUser", "superAdmin"]}>
      <Dashboard />
    </RoleRoute>
  }
/>

          <Route
            path="branches"
            element={
              <RoleRoute allowed={["admin","superAdmin"]}>
                <Branches />
              </RoleRoute>
            }
          />

          <Route
            path="candidates"
            element={
              <RoleRoute allowed={["admin", "branchUser","superAdmin"]}>
                <Candidates />
              </RoleRoute>
            }
          />
          
          <Route
            path="assets"
            element={
              <RoleRoute allowed={["admin", "branchUser","superAdmin"]}>
                <AssetsManagement />
              </RoleRoute>
            }
          />
<Route
  path="logs"
  element={
    <RoleRoute allowed={["admin","superAdmin"]}>
      <Log />
    </RoleRoute>
  }
/>

          <Route
            path="project"
            element={
              <RoleRoute allowed={["admin","superAdmin"]}>
                <Project />
              </RoleRoute>
            }
          />
        </Route>

        {/* Fallback */}
      <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>

      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
